/**
 * Keys for the location filters map.
 *
 * These keys are also used for applying querystring values to the search api.
 */
export enum LocationFilter {
  Location = 'location'
}
